import type { Notification } from '../services/api/notifications';

export function getNotificationDisplayMessage(notification: Notification): string {
  const message = notification.message || '';
  const totalReturn = notification.metadata?.summary?.totalReturn;

  if (typeof totalReturn !== 'number' || !Number.isFinite(totalReturn)) {
    return message;
  }

  if (message.includes('N/A return')) {
    return message.replace('N/A return', `${totalReturn.toFixed(2)}% return`);
  }

  return message;
}
